export enum Maintenance {
    TOP_NOTIFICATION_MESSAGE_ENABLED = 'header_notification_enabled',
    TOP_NOTIFICATION_MESSAGE_TEXT = 'header_notification_text',
}
